// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@rugby/XDL/types";
import { css } from "styled-components";

const shape = (isFill = true) => {
    const disk = css`
        border-radius: 50%;
        background-color: ${getColor("common.ui1")};
    `;

    const circle = css`
        border-radius: 50%;
        border: 2px solid;
        border-color: ${getColor("common.ui1")};
        background: transparent;
    `;

    return css`
            list-style: none;
            li {
                position: relative;
                &::before {
                    content: " ";        
                    height: 6px;
                    width: 6px;
                    ${isFill ? disk : circle}
                    position: absolute;
                    top: 9px;
                    left: -15px;                 
            }
        `;
};

export default {
    defaultProps: {
        css: css`
            padding-left: 20px;
            li {
                margin: 0;
                padding: 0;
            }
            ul,
            ol {
                margin: 0;
                padding: 5px 0 5px 20px;
            }
        `,
    },
    unorderedListProps: {
        css: css`
            ${shape(true)}
            ul {
                list-style: circle;
                ${shape(false)}
            }
        `,
    },
    orderedListProps: {
        css: css`
            list-style-type: number;
            ol {
                list-style-type: lower-alpha;
            }
        `,
    },
} as xBaseTheme["lists"];
